import React from 'react'
import TeacherDatabase from '../TeacherDatabase'
import AdminTasks from '../AdminTasks/AdminTasks'
import {AdminMenu} from '../AdminMenu/AdminMenu'
import StudentWorkflows from '../AdminWorkflows/StudentWorkflows'
import TeacherWorkflows from '../AdminWorkflows/TeacherWorkflows'
import AdminApplications from '../AdminApplications/AdminApplications'
import Dashboard from '../Dashboard/Dashboard'
import StudentDatabase from '../StudentDatabase/StudentDatabase'
//import SidePanel from '../SidePanel/SidePanel'
import './admin-master.css'
import BlogCreator from '../Blog/BlogCreator'
import BlogReview from '../Blog/BlogReview/BlogReview'
import Timesheets from '../Timesheets/Timesheets'
import NeedsToResetPassword from '../NeedsToResetPassword'
import NoteArea from '../NoteArea/NoteArea'
import CreateEvent from '../NoteArea/CreateEvent/CreateEvent'
import axios from 'axios'
import { baseUrl } from '../assets/Animations'
import SchoolSEO from '../SchoolSEO/SchoolSEO'
import FamiliesToWatch from '../FamiliesToWatch/FamiliesToWatch'
import StudentModal2022 from '../StudentModal2022/StudentModal2022'
import { ErrorPopup } from '../ErrorPopup/ErrorPopup'
import TempDashboard from '../TempDashboard/TempDashboard'
import CancellationSpreadsheet from '../CancellationSpreadsheet/CancellationSpreadsheet'
import InvoiceViewMaster from '../InvoiceViewMaster/InvoiceViewMaster'
import InquiryDatabase from '../InquiryDatabase/InquiryDatabase'

import {socket, joinARoom, disconnectSocket} from '../service/socket'
import StudentWorkflows2022 from '../AdminWorkflows/StudentWorkflows2022'
import TeacherAvailability from '../TeacherAvailability/TeacherAvailability'
import Calendar from '../Calendar/Calendar'
import TaxInfoView from '../TaxInfoView/TaxInfoView'

const AdminMaster = (props) => {
    const [currentView, setCurrentView] = React.useState('tasks')
    const [blogToReview, setBlogToReview] = React.useState('')
    const [needsToReset, setNeedsToReset] = React.useState(Boolean)
    const [showNotes, setShowNotes] = React.useState(false)
    const [createNote, setCreateNote] = React.useState(false)
    const [editNote, setEditNote] = React.useState(false)
    const [sideBarNotes, setSideBarNotes] = React.useState([])
    const [studentModal, setStudentModal] = React.useState(false)
    const [invoiceView, setInvoiceView] = React.useState(false)
    const [error, setError] = React.useState(false)
    const [idToLogOut, setIdToLogOut] = React.useState(false)
    const [whosLoggedIn, setWhosLoggedIn] = React.useState([])
    const [todos, setTodos] = React.useState([])
    const [studentOnboardingWorkflows, setStudentOnboardingWorkflows] = React.useState([])
    const [studentOnboardingCardsInUse, setStudentOnboardingCardsInUse] = React.useState([])
    let fancyFeast = new Audio("/inquiry.wav")

    let myToken = localStorage.getItem('token')
    let myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
        if(JSON.stringify(props.userData) !== JSON.stringify({})){
            props.getApplications()
            setNeedsToReset(props.userData.NeedsToReset)
            
            socket.emit('login', props.userData.Name)
        }
        const handleSocketConnection = () => {
            if (document.visibilityState === 'visible') {
                if(socket.connected === false) {
                    socket.connect()
                    socket.emit('login', props.userData.Name)
                }
            } else {
                disconnectSocket()
            }
          }

        window.addEventListener('visibilitychange', handleSocketConnection)

        return () => {window.removeEventListener('visibilitychange', handleSocketConnection)}
    }, [])

    //--------------------------------------------------

    React.useEffect(() => {
        socket.on('login', (loginInfo) => {
            setWhosLoggedIn([...loginInfo.users])
            setStudentOnboardingCardsInUse([...loginInfo.studentWorkflows])
        })

        socket.on('logging-out', (loggingOutInfo) => {
            setWhosLoggedIn([...loggingOutInfo.users])
            setStudentOnboardingCardsInUse([...loggingOutInfo.studentWorkflows])
        })

        socket.on('inquiry', (card) => {
            playFancyFeast()
            setStudentOnboardingWorkflows(prev => [...prev, card])
        })
        socket.on('openStudentWorkflow', (id) => {
            if(id.emitter !== props.userData.Name) {
                setStudentOnboardingCardsInUse([...studentOnboardingCardsInUse, id])
                //document.getElementById(id.data).style.border = "2px solid fuchsia"
            }
        })
        socket.on('closeAndSaveStudentWorkflow', (data) => {
            setStudentOnboardingCardsInUse([...data.updatedList])
        })
        socket.on('closeAndDeleteStudentWorkflow', (packet) => {
            setStudentOnboardingWorkflows((prev) => prev.filter((card) => card.todoId !== packet.data))
        })
    }, [socket])

    //--------------------------------------------------

    React.useEffect(() => {
        if(studentModal) {
            getNotesAboutModal(studentModal.familyId, 'familyId', studentModal.familyName)
        } else {
            props.getFamiliesToWatch()
        }
    }, [studentModal])

    React.useEffect(() => {
        if(showNotes.id) {
            getNotes()
        }
    }, [showNotes])

    const playFancyFeast = () => {
        fancyFeast.muted = false
        fancyFeast.play()
    }

    const getFamilyData = (familyId) => {
        axios.get(`${baseUrl}/school-management/${familyId}`)
        .then((res) => {
            setStudentModal(res.data)
        })
        .catch((err) => {
            setError(err)
            console.log(err)
        })
    }

    const closeAndSaveFamilyModal = () => {
        axios.put(`${baseUrl}/school-management-new/${studentModal.familyId}`,studentModal, myHeader)
        .then((res) => {
            setStudentModal(false)
            closeSideNotesWithAnimation()
        })
        .catch((err) => {
            setError(err)
            console.log(err)
        })
    }

    const deleteFamily = () => {
        axios.delete(`${baseUrl}/school-management/${studentModal.familyId}`, myHeader)
        .then((res) => {
            setStudentModal(false)
            closeSideNotesWithAnimation()
        })
        .catch((err) => {
            setError(err)
            console.log(err)
        })
    }

    const getNotes = () => {
        axios.get(`${baseUrl}/notes/${showNotes.type}/${showNotes.id}`)
        .then((res) => {
            res.data.sort((a,b) => {
                return new Date(b.date) - new Date(a.date)
            })
            setSideBarNotes(res.data)
        })
        .catch((err) => {
            console.log(err)
        }) 
    }

    const createNoteFunc = () => {
        let myNote = {
            id: Math.random().toString(16).slice(2),
            date: new Date(),
            type: showNotes.type,
            author: props.userData.Name,
            important: false,
            connections: [],
            details: '',
            applicationId: '',
            invoiceId: '',
            onboardingId: '',
            familyId: '',
            tasksId: '',
            teacherId: '',
            timesheetId: '',
            workflowId: '',
            miscId1: '',
            miscId2: '',
            miscId3: '',
            miscId4: '',
            miscId5: '',
            miscId6: '',
            miscId7: '',
            miscId8: '',
            miscId9: '',
            miscId10: '',
            displayName: showNotes.displayName,
        }
        myNote[showNotes.type] = showNotes.id
        setCreateNote(myNote)
    }
    const editNotesConnections = (type, id) => {
        let myNote = createNote
        myNote[type] = id
        setCreateNote({...myNote})
    }

    const editEditNotesConnections = (type, id) => {
        let myNote = editNote
        myNote[type] = id
        setEditNote({...myNote})
    }

    const getNotesAboutModal = (id, type, nameToDisplay) => {
        setShowNotes({
            type,
            id,
            displayName: nameToDisplay
        })
    }

    const sendTheEvent = () => {
        //const { ...props } = createNote;
        axios.post(`${baseUrl}/notes`, {
            note: {
                id: Math.random().toString(16).slice(2),
                date: new Date(),
                type: createNote.type,
                author: props.userData.Name,
                important: createNote.important,
                connections: createNote.connections,
                details: createNote.details,
                applicationId: createNote.applicationId,
                invoiceId: createNote.invoiceId,
                onboardingId: createNote.onboardingId,
                familyId: createNote.familyId,
                tasksId: createNote.tasksId,
                teacherId: createNote.teacherId,
                timesheetId: createNote.timesheetId,
                workflowId: createNote.workflowId,
                miscId1: createNote.miscId1,
                miscId2: createNote.miscId2,
                miscId3: createNote.miscId3,
                miscId4: createNote.miscId4,
                miscId5: createNote.miscId5,
                miscId6: createNote.miscId6,
                miscId7: createNote.miscId7,
                miscId8: createNote.miscId8,
                miscId9: createNote.miscId9,
                miscId10: createNote.miscId10
            }
          })
          .then((res) => {
              getNotes()
              setCreateNote(false)
          })
          .catch((err) => {
            console.log(err)
          })
    }

    const editTheEvent = () => {
        axios.put(`${baseUrl}/notes/${editNote.id}`, {
            note: editNote
          })
          .then((res) => {
            getNotes()
            setEditNote(false)
          })
          .catch((err) => {
            console.log(err)
          })
    }

    const deleteTheEvent = () => {
        axios.delete(`${baseUrl}/notes/${editNote.id}`)
        .then((res) => {
            getNotes()
            setEditNote(false)
        })
        .catch((err) => console.log(err))
    }

    const closeSideNotesWithAnimation = () => {
        document.getElementById('note-area-wrapper').style.opacity = 0
        document.getElementById('note-area-wrapper').style.right = '-350px'
        setTimeout(() => {
            setShowNotes(false)
        }, 300)
    }

    const editStudentInfo = (theIndex, key, theChange, id) => {
            let student = studentModal
            if(key === "addressLine1" || key === "city" || key === "state" || key === "zipcode" || key === "addressLine2") {
                student.address[key] = theChange
            } else if (id === 'allRates') {
                student.students[theIndex].allRates[key] = theChange
            } else if (id === 'new-instrument') {
                student.students[theIndex].instrumentList = theChange
            } else {
                id === "student-info" ? student.students[theIndex][key] = theChange : student[key] = theChange
            }
            setStudentModal({...student})
    }

    return(
        <div className="admin-master">
            {needsToReset && <NeedsToResetPassword setNeedsToReset={setNeedsToReset} userData={props.userData} />}
            <AdminMenu setCurrentView={setCurrentView} currentView={currentView} applications={props.applications} familiesToWatch={props.familiesToWatch} userData={props.userData} logout={props.logout} whosLoggedIn={whosLoggedIn} />
            {currentView === 'teachers' && <TeacherDatabase logout={() => props.logout()} userData={props.userData} user={props.user} closeSideNotesWithAnimation={closeSideNotesWithAnimation} setShowNotes={setShowNotes} getNotesAboutModal={getNotesAboutModal}  getFamilyData={getFamilyData} studentModal2022={studentModal} />}
            {currentView === 'tasks' && <AdminTasks userData={props.userData} closeSideNotesWithAnimation={closeSideNotesWithAnimation} setShowNotes={setShowNotes} sideBarNotes={sideBarNotes} getNotesAboutModal={getNotesAboutModal} todos={todos} setTodos={setTodos} />}
            {currentView === 'student-onboarding' && <StudentWorkflows userData={props.userData} closeSideNotesWithAnimation={closeSideNotesWithAnimation} setShowNotes={setShowNotes} sideBarNotes={sideBarNotes} getNotesAboutModal={getNotesAboutModal} />}
            {currentView === 'student-onboarding2' && <StudentWorkflows2022 userData={props.userData} closeSideNotesWithAnimation={closeSideNotesWithAnimation} setShowNotes={setShowNotes} sideBarNotes={sideBarNotes} getNotesAboutModal={getNotesAboutModal} socket={socket} workflows={studentOnboardingWorkflows} setWorkflows={setStudentOnboardingWorkflows} studentOnboardingCardsInUse={studentOnboardingCardsInUse} setStudentOnboardingCardsInUse={setStudentOnboardingCardsInUse} />}
            {currentView === 'families-to-watch' && <FamiliesToWatch familiesToWatch={props.familiesToWatch} moreAttentionFamilies={props.moreAttentionFamilies} getFamilyData={getFamilyData} />}
            {currentView === 'temp-dashboard' && <TempDashboard />}
            {currentView === 'inquiry-database' && <InquiryDatabase />}
            {currentView === 'calendar' && <Calendar userData={props.userData} socket={socket} />}
            {/* {currentView === 'teacher-onboarding' && <TeacherWorkflows userData={props.userData} getNotesAboutModal={getNotesAboutModal} setShowNotes={setShowNotes}/>} */}
            {currentView === 'teacher-availability' && <TeacherAvailability />}
            {currentView === 'hiring' && <AdminApplications getApplications={props.getApplications} removeApplication={props.removeApplication} applications={props.applications} userData={props.userData} getNotesAboutModal={getNotesAboutModal} setShowNotes={setShowNotes}/>}
            {currentView === 'students' && <StudentDatabase userData={props.userData} closeSideNotesWithAnimation={closeSideNotesWithAnimation} setShowNotes={setShowNotes} getNotesAboutModal={getNotesAboutModal} getFamiliesToWatch={props.getFamiliesToWatch} setInvoiceView={setInvoiceView} />}
            {currentView === 'dashboard' && <Dashboard userData={props.userData} />}
            {currentView === 'blog' && <BlogCreator reviewing={false} userData={props.userData} setCurrentView={setCurrentView} />}
            {currentView === 'review' && <BlogReview published={false} personal={false} userData={props.userData} setCurrentView={setCurrentView} setBlogToReview={setBlogToReview}/>}
            {currentView === 'mydrafts' && <BlogReview published={false} personal={true} userData={props.userData} setCurrentView={setCurrentView} setBlogToReview={setBlogToReview}/>}
            {currentView === 'blogtoreview' && <BlogCreator userData={props.userData} reviewing={blogToReview} setCurrentView={setCurrentView} />}
            {currentView === 'billing' && <Timesheets userData={props.userData} getFamilyData={getFamilyData} />}
            {currentView === 'cancellations' && <CancellationSpreadsheet userData={props.userData} />}
            {currentView === 'school-seo' && <SchoolSEO userData={props.userData} />}
            {currentView === 'tax-info' && <TaxInfoView />}
            {showNotes && <NoteArea showNotes={showNotes} sideBarNotes={sideBarNotes} createNoteFunc={createNoteFunc} userData={props.userData} setEditNote={setEditNote} />}
            {createNote && <CreateEvent edit={false} createNote={createNote} deleteTheEvent={deleteTheEvent} setCreateNote={setCreateNote} sendTheEvent={sendTheEvent} editNotesConnections={editNotesConnections} />}
            {editNote && <CreateEvent edit={true} createNote={editNote} deleteTheEvent={deleteTheEvent} setCreateNote={setEditNote} sendTheEvent={editTheEvent} editNotesConnections={editEditNotesConnections} />}
            {studentModal && <StudentModal2022 setStudentModal={setStudentModal} studentModal={studentModal} editStudentInfo={editStudentInfo} familyId={studentModal.familyId} closeSideNotesWithAnimation={closeSideNotesWithAnimation} getNotesAboutModal={getNotesAboutModal} setError={setError} closeAndSaveFamilyModal={closeAndSaveFamilyModal} deleteFamily={deleteFamily} setInvoiceView={setInvoiceView} />}
            {invoiceView && <InvoiceViewMaster invoice={invoiceView} setInvoiceView={setInvoiceView} />}
            {error && <ErrorPopup error={error} setError={setError} />}
            {/* <SidePanel 
                userData={props.userData} 
                adminConversations={props.adminConversations} 
                disconnectFromSocket={props.disconnectFromSocket} 
                sendTheMessage={props.sendTheMessage}
                getJustTheMostRecentMessages={props.getJustTheMostRecentMessages}
                chooseConversationToJoin={props.chooseConversationToJoin}
                openedConversation={props.openedConversation}
                appendAReceivedMessage={props.appendAReceivedMessage}
                anythingUnread={props.anythingUnread}
                setAnythingUnread={props.setAnythingUnread}
                unreadMessageRooms={props.unreadMessageRooms}
                markRoomAsRead={props.markRoomAsRead}
                setUnreadFlag={props.setUnreadFlag}
            /> */}
        </div>
    )
}
export default AdminMaster